module.exports = __webpack_public_path__ + "static/media/radiology.b300e185.png";